import { Moon, Circle, Clock } from "lucide-react";
import { eventSuffix } from "./calUtils";

const MoonMarks = ({ moons }) => moons.filter((m) => m.event).map((m) => (
  <span key={m.index} title={`${m.event === "full" ? "Full" : "New"} moon · ${m.name}`} className="inline-flex items-center gap-0.5 text-[10px] text-[#E5E7EB]/80">
    {m.event === "full" ? <Circle className="h-2.5 w-2.5 fill-[#F3EBDD] text-[#F3EBDD]" /> : <Moon className="h-2.5 w-2.5" />}
    <span className="hidden md:inline">{m.name}</span>
  </span>
));

function DayCell({ day, today, onClick }) {
  const items = [...day.events.map((e) => ({ ...e, tl: false })), ...day.timeline_events.map((e) => ({ ...e, tl: true }))];
  return (
    <button type="button" onClick={() => onClick(day)} data-testid={`cal-day-${day.day}`}
      className={`group min-h-[64px] sm:min-h-[96px] rounded-md border p-1.5 text-left transition-colors hover:border-[#F59E0B]/60 hover:bg-[#F59E0B]/5 ${today ? "border-[#F59E0B] bg-[#F59E0B]/5" : "border-[#2D3442] bg-[#13171F]/60"}`}>
      <div className="flex items-center justify-between gap-1">
        <span className={`font-mono-lf text-xs ${today ? "text-[#F59E0B]" : "text-[#A8A090]"}`}>{day.day}</span>
        <span className="flex gap-1"><MoonMarks moons={day.moons} /></span>
      </div>
      <div className="mt-1 space-y-0.5">
        {items.slice(0, 3).map((e, i) => (
          <div key={`${e.id}-${i}`} className="truncate rounded px-1 py-0.5 text-[10px] sm:text-[11px] leading-tight"
            style={e.tl ? { background: "#8B5CF622", color: "#C4B5FD" } : { background: `${e.color}22`, color: e.color }}>
            {e.tl && <Clock className="mr-0.5 inline h-2.5 w-2.5" />}{e.title}<span className="hidden sm:inline opacity-70">{e.tl ? "" : eventSuffix(e)}</span>
          </div>
        ))}
        {items.length > 3 && <div className="text-[10px] text-[#A8A090]">+{items.length - 3} more</div>}
      </div>
    </button>
  );
}

export const MonthGrid = ({ data, todayDay, onDay }) => {
  const cols = data.weekdays.length || 7;
  const lead = data.first_weekday ?? 0;
  return (
    <div className="overflow-x-auto lf-scroll" data-testid="cal-month-grid">
      <div className="grid gap-1.5" style={{ gridTemplateColumns: `repeat(${cols}, minmax(${cols > 7 ? 72 : 40}px, 1fr))` }}>
        {data.weekdays.map((w) => <div key={w} className="lf-label truncate px-1 pb-1 text-center">{w.slice(0, cols > 7 ? 4 : 3)}</div>)}
        {Array.from({ length: lead }).map((_, i) => <div key={`b${i}`} />)}
        {data.days.map((d) => <DayCell key={d.d} day={d} today={todayDay === d.day} onClick={onDay} />)}
      </div>
    </div>
  );
};
